import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import DataSecurityPrivacyDetails from '../../subdepartmentdetails/DataSecurityPrivacy'


function DataSecurityPrivacy() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Data Security and Privacy Management || Innovation and Technology";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Innovation Technology"
            title="Data Security Privacy"
            subtitledown="Department of Innovation & Technology"
           />
            <DataSecurityPrivacyDetails/>
        </div>
    </>
  )
}

export default DataSecurityPrivacy